import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { Urls } from "../../shared/urls";

@Injectable()
export class DownloadContractService {
  user: any;
  token: string;

  constructor(private http: HttpClient) {}

  downloadContract(id: string, reqBody, reqHeader) {
    return Observable.create(observer => {
      this.http.post(Urls.download_contract + id, reqBody, { headers: reqHeader }).subscribe(
        res => {
          observer.next(res);
          observer.complete();
        },
        err => {
          observer.error(err);
        }
      );
    });
  }
}
